import React from 'react';
import Accordion from '../../Accordion';
import { RichTextField } from '../../RichTextField/RichTextField';
import * as styles from './../StrapiEnglishLevelsAccordion/StrapiEnglishLevelsAccordion.module.scss';
import { compact } from 'lodash';
import StrapiButton from '../../StrapiLink/StrapiButton';

  const AccordionContent = (row: any) => {
    return (
      <div className={styles.content}>
        <div className={styles.infoBlocks}>
          <div className='mb-4'>
            <RichTextField className={styles.text} content={row.content} />
          </div>
          <div>
          {
            row?.cta ? (<StrapiButton icon='Arrow' type="primary" {...row.cta} />):null
          }
        </div>
        </div>
      </div>
    );
  };

export const StrapiAccordion = ({
    accordion
}:any) => {
  return (
    <div className="container">
        {accordion?.accordion_title && <h2 className={`title is-3 mb-4 mt-5`}>{accordion?.accordion_title}</h2>}
      <Accordion
        data={compact(accordion?.rows).map((row) => ({
          title: row?.row_title,
          children: <AccordionContent {...row} />
        }))}
      />
    </div>
  );
};